<ion-header>
  <ion-toolbar>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
  <div class="no_results" *ngIf="users && users.length == 0">{{ texts?.no_results }}</div>
  <ion-list>
    <button [ngClass]="{'is-unread': user.newMessagesCount  }" class="card-with-image inbox-button ion-margin-block"
            *ngFor="let user of users; let i = index;" tappable
            >
      <div class="right" (click)="goToDialogPage(user,i)"
           [ngStyle]="{ 'background-image': 'url('  + (user.user.mainImage?.url) + ')'}">
      </div>
      <div class="left">
        <div class="subsTitle" (click)="goToDialogPage(user,i)">
          <h3>{{ user.user.nickName }}</h3>
          <ion-badge *ngIf="user.newMessagesCount">{{user.newMessagesCount}}</ion-badge>
        </div>
        <p (click)="goToDialogPage(user,i)" [innerHTML]="user.recentMessage.text|ellipsis:48"></p>
        <span (click)="goToDialogPage(user,i)" class="date">{{ user.recentMessage.date }}</span>
        <span *ngIf="user.user.id!=1" class="del"><ion-icon
          (click)="deleteDialog(user,i)" tappable class="delete" name="trash-outline" size="small">
        </ion-icon></span>
      </div>
    </button>
  </ion-list>
  <div *ngIf="params.results.loader == true" class="loader"><img src="assets/img/loader.gif"></div>
  <ion-infinite-scroll (ionInfinite)="loadMoreDialogues($event)" #infiniteScroll>
    <ion-infinite-scroll-content></ion-infinite-scroll-content>
  </ion-infinite-scroll>
</ion-content>
<ion-footer>
  <ion-toolbar>
  </ion-toolbar>
</ion-footer>
